import { EHeatingType } from '../../../../api-models/common/json_query';

export const HEATING_TYPES_MAP_VALUE_TO_LABEL = {
  [EHeatingType.Furnace]: 'Печь',
  [EHeatingType.Fireplace]: 'Камин',
  [EHeatingType.None]: 'Без отопления',
  [EHeatingType.Gas]: 'Центральное газовое',
  [EHeatingType.Coal]: 'Угольное отопление',
  [EHeatingType.Electric]: 'Электрическое',
  [EHeatingType.AutonomousGas]: 'Автономное газовое',
  [EHeatingType.Diesel]: 'Дизельное',
  [EHeatingType.SolidFuelBoiler]: 'Твердотопливный котел',
};
